import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierActivityHistory extends Layout {
    sourceActivityHistory: DataSource;
    tableActivityHistory: Table;
}
